
/**
 * 予約タスクの実行エンジン。reserve(task)されると、指定秒数後に実行する。その間新規にタスクが追加されたら、前のタスクの実行はやめ、最新のタスクのみを実行する。
 */
export default class Runner {
  constructor(timeout) {
    this.timeout = timeout;
    this.lastTask = null;
    this.timer = null;
  }

  flush() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
    if (!this.lastTask) {
      return;
    }
    this.lastTask();
    this.lastTask = null;
}

  reserve(task) {
    this.lastTask = task;
    if (this.timer) {
      return;
    }
    this.timer = setTimeout(() => {
      this.timer = null;
      if (!this.lastTask) {
        console.warn('No tasks');
        return;
      }
      console.log('Performing task...');
      this.lastTask();
      this.lastTask = null;
    }, this.timeout);
  }

}